import axiosInstance from "../../translator";
import { userWorkspaceManager as workspace } from "../../constants/apis/apiEndpoints";

export const fetchWorkspaceList = async (data) => {
  return axiosInstance
    .get(`${workspace?.userWorkspaceLabsList}?${data}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const fetchWorkspaceLabTimer = async (data) => {
  return axiosInstance
    .get(`${workspace?.userWorkspaceLabTimer}/${data}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};
